import afs300w from '../images/transactions/afs-300w-white-min.jpg';
import sunseeker300w from '../images/transactions/sunseeker-300w-min.jpeg';
import veransa300w from '../images/transactions/veransa-300w-min.jpeg';
import skykick300w from '../images/transactions/skykick-300w-min.jpeg';
import elevatenew from '../images/transactions/elevate-new-min.jpg';
import mutuo300w from '../images/transactions/mutuo-300w-min.jpeg';
import channel300w from '../images/transactions/channel-300w-min.jpeg';
import Photonic300w from '../images/transactions/Photonic-300w-min.jpeg';
import FlexShopper300w from '../images/transactions/FlexShopper-300w-min.jpeg';
import avaFin300w from '../images/transactions/AvaFin-300w-min.jpg';
import capfusionnew from '../images/transactions/capfusion-new-min.jpg';
import privlonew from '../images/transactions/privlo-new-min.jpg';
import benchnew from '../images/transactions/bench-new-min.jpg';
import DriveFactor300w from '../images/transactions/DriveFactor-300w-min.jpeg';
import NexisCard300w from '../images/transactions/NexisCard-300w-min.jpeg';
import creditmaxnew from '../images/transactions/creditmax-new-min.jpg';
import AstorInvestment300w from '../images/transactions/AstorInvestment-300w-min.jpeg';
import equiductnew from '../images/transactions/equiduct-new-min.jpg';
import piconew from '../images/transactions/pico-2022-min.jpg';
import UrbanFinancial300w from '../images/transactions/UrbanFinancial-300w-min.jpeg';
import Knight300w from '../images/transactions/Knight-300w-min.jpeg';
import Ballista300w from '../images/transactions/Ballista-300w-min.jpeg';
import currenexnew from '../images/transactions/currenex-new-min.jpg';
import cashedgenew from '../images/transactions/cashedge-new-min.jpg';
import velocitynew from '../images/transactions/velocity-new-min.jpg';
import CheckSmart300w from '../images/transactions/CheckSmart-300w-min.jpeg';
import newnew from '../images/transactions/new-new-min.jpg';
import resmaenew from '../images/transactions/resmae-new-min.jpg';

var transactions =
  [
    {
      'Logo': 'nologo',
      'Name': 'Project Neptune',
      'Description': '',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 90,000,000',
      'Year': 2024,
      'Investor': 'Undisclosed',
      'Order': 0.01
    },
    {
      'Logo': 'nologo',
      'Name': 'Project Phoenix',
      'Description': 'UK Real Estate Developer Financing Provider',
      'MM': 'MM',
      'Type': 'Acquisition',
      'Amount': '£ 50,000,000',
      'Year': 2024,
      'Investor': 'Undisclosed',
      'Order': 0.02
    },
    {
      'Logo': afs300w,
      'Name': 'AFS',
      'Description': 'Lending Analytics Provider',
      'MM': 'MM',
      'Type': 'Acquisition',
      'Amount': 'Undisclosed',
      'Year': 2023,
      'Investor': 'PCG US Holdings',
      'Order': 0.03
    },
    {
      'Logo': sunseeker300w,
      'Name': 'Sunseeker',
      'Description': 'Real Estate Development of Sunseeker Resort Charlotte Harbor',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 350,000,000',
      'Year': 2021,
      'Investor': 'Castlelake LP and PIMCO',
      'Order': 1
    },
    {
      'Logo': veransa300w,
      'Name': 'Veransa',
      'Description': 'Yard Waste Recycling Business',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 30,000,000',
      'Year': 2021,
      'Investor': 'RFE Investments and Middlemarch Capital Partners',
      'Order': 2
    },
    {
      'Logo': skykick300w,
      'Name': 'Skykick',
      'Description': 'Cloud Automation SAAS Company',
      'MM': 'MM',
      'Type': 'Debt and Equity Raise',
      'Amount': '$ 130,000,000',
      'Year': 2021,
      'Investor': 'Morgan Stanley and Trebuchet Capital',
      'Order': 3
    },
    {
      'Logo': elevatenew,
      'Name': 'Elevate',
      'Description': 'Global Outsourced Legal Services Company',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 25,000,000',
      'Year': 2020,
      'Investor': 'Kayne Anderson Partners',
      'Order': 4
    },
    {
      'Logo': mutuo300w,
      'Name': 'Mutuo Financiera',
      'Description': 'Commercial Auto Leasing Company',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 100,000,000',
      'Year': 2019,
      'Investor': 'Crayhill Capital Management',
      'Order': 5
    },
    {
      'Logo': channel300w,
      'Name': 'Channel Partners Capital',
      'Description': 'Small Business Lender',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 45,000,000',
      'Year': 2018,
      'Investor': 'Elliot Capital Management',
      'Order': 6
    },
    {
      'Logo': Photonic300w,
      'Name': 'Photonic Capital',
      'Description': 'Lease-To-Own Led Lighting Company',
      'MM': 'MM',
      'Type': 'Debt and Equity Raise',
      'Amount': '$ 100,000,000',
      'Year': 2017,
      'Investor': 'Capstone Capital',
      'Order': 7
    },
    {
      'Logo': 'nologo',
      'Name': 'Project Dynamo',
      'Description': 'Energy Equipment Reseller',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 10,000,000',
      'Year': 2016,
      'Investor': 'Old Lane Partners and Middlemarch Capital Partners',
      'Order': 8
    },
    {
      'Logo': FlexShopper300w,
      'Name': 'FlexShopper',
      'Description': 'Lease-To-Own Finance Company',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 22,000,000',
      'Year': 2016,
      'Investor': 'PIMCO and Middlemarch Capital Partners',
      'Order': 9
    },
    {
      'Logo': avaFin300w,
      'Name': 'Cream Finance',
      'Description': 'Online Consumer Lender',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '€ 21,000,000',
      'Year': 2016,
      'Investor': 'Capitec Bank',
      'Order': 10
    },
    {
      'Logo': capfusionnew,
      'Name': 'Capfusion',
      'Description': 'Small Business Lender',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 60,000,000',
      'Year': 2016,
      'Investor': 'Main Street Financial',
      'Order': 11
    },
    {
      'Logo': 'nologo',
      'Name': 'Online Consumer Lender',
      'Description': 'Short-Term Consumer Lender',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 17,500,000',
      'Year': 2015,
      'Investor': 'Bastion Capital',
      'Order': 12
    },
    {
      'Logo': FlexShopper300w,
      'Name': 'Flexshopper',
      'Description': 'Lease-To-Own Finance Company',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 100,000,000',
      'Year': 2015,
      'Investor': 'Waterfall Asset Management',
      'Order': 13
    },
    {
      'Logo': FlexShopper300w,
      'Name': 'Flexshopper',
      'Description': 'Lease-To-Own Finance Company',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 9,350,000',
      'Year': 2015,
      'Investor': 'Waterfall Asset Management and Middlemarch Partners',
      'Order': 14
    },
    {
      'Logo': privlonew,
      'Name': 'Privlo',
      'Description': 'Non-Conforming Mortgage Lender',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 350,000,000',
      'Year': 2014,
      'Investor': 'Waterfall Asset Management',
      'Order': 15
    },
    {
      'Logo': 'nologo',
      'Name': 'Online Consumer Lender',
      'Description': 'Online Installment Lender',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 25,000,000',
      'Year': 2014,
      'Investor': 'Undisclosed',
      'Order': 16
    },
    {
      'Logo': benchnew,
      'Name': 'Bench',
      'Description': 'Outsourced Accounting Services',
      'MM': 'MM',
      'Type': 'Equity Investment',
      'Amount': '$ 8,000,000',
      'Year': 2012,
      'Investor': 'Altos Ventures and Middlemarch Partners',
      'Order': 17
    },
    {
      'Logo': 'nologo',
      'Name': 'Online Consumer Lender',
      'Description': 'Online Consumer Lender',
      'MM': 'MM',
      'Type': 'Debt Raise',
      'Amount': '$ 20,000,000',
      'Year': 2012,
      'Investor': 'Vector Capital',
      'Order': 18
    },
    {
      'Logo': 'nologo',
      'Name': 'Online Consumer Lender',
      'Description': 'Online Consumer Lender',
      'MM': 'MM',
      'Type': 'Equity Raise',
      'Amount': '$ 80,000,000',
      'Year': 2012,
      'Investor': 'Vector Capital',
      'Order': 19
    },
    {
      'Logo': DriveFactor300w,
      'Name': 'Drive Factor',
      'Description': 'Insurance Telematics For Autos',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 2,500,000',
      'Year': '',
      'Investor': 'Safeguard Scientifics',
      'Order': 20
    },
    {
      'Logo': benchnew,
      'Name': 'Bench',
      'Description': 'Outsourced Accounting Services',
      'MM': 'PRIOR',
      'Type': 'Equity Investment',
      'Amount': '$ 2,000,000',
      'Year': '',
      'Investor': 'Undisclosed and Middlemarch Principals',
      'Order': 21
    },
    {
      'Logo': NexisCard300w,
      'Name': 'Prepaid Ventures',
      'Description': 'Pre-Paid Debit Card Processor',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 1,000,000',
      'Year': '',
      'Investor': 'Individual Investors and Middlemarch Principals',
      'Order': 22
    },
    {
      'Logo': creditmaxnew,
      'Name': 'CreditMax',
      'Description': 'Charged-Off Credit Trading Platform',
      'MM': 'PRIOR',
      'Type': 'Debt Raise',
      'Amount': '$ 5,500,000',
      'Year': '',
      'Investor': 'Metropolitan Partners and Partner Re',
      'Order': 23
    },
    {
      'Logo': creditmaxnew,
      'Name': 'CreditMax',
      'Description': 'Charged-Off Credit Trading Platform',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 2,500,000',
      'Year': '',
      'Investor': 'Partnerre, Metropolitan Partners, and Middlemarch Principals',
      'Order': 24
    },
    {
      'Logo': AstorInvestment300w,
      'Name': 'Astor Investment Management',
      'Description': 'Actively Managed Etf Issuer',
      'MM': 'PRIOR',
      'Type': 'Acquisition',
      'Amount': '$ 20,000,000',
      'Year': '',
      'Investor': 'Knight Capital',
      'Order': 25
    },
    {
      'Logo': equiductnew,
      'Name': 'Equiduct',
      'Description': 'European Equity Exchange',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 10,000,000',
      'Year': '',
      'Investor': 'Knight Capital',
      'Order': 26
    },
    {
      'Logo': piconew,
      'Name': 'Pico Trading',
      'Description': 'Capital Markets Technology',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 6,500,000',
      'Year': '',
      'Investor': 'Knight Capital',
      'Order': 27
    },
    {
      'Logo': UrbanFinancial300w,
      'Name': 'Urban Financial Group',
      'Description': 'Reverse Mortgage Lender',
      'MM': 'PRIOR',
      'Type': 'Acquisition',
      'Amount': '$ 25,000,000',
      'Year': '',
      'Investor': 'Knight Capital',
      'Order': 28
    },
    {
      'Logo': Knight300w,
      'Name': 'Knight Capital',
      'Description': 'Retail Fx Trading',
      'MM': 'PRIOR',
      'Type': 'Sale',
      'Amount': 'Undisclosed',
      'Year': '',
      'Investor': 'FXCM',
      'Order': 29
    },
    {
      'Logo': Ballista300w,
      'Name': 'Ballista',
      'Description': 'Block Options Trading Platform',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 12,000,000',
      'Year': '',
      'Investor': 'Knight Capital',
      'Order': 30
    },
    {
      'Logo': currenexnew,
      'Name': 'CurrenEx',
      'Description': 'Foreign Exchange Trading Platform',
      'MM': 'PRIOR',
      'Type': 'Acquisition',
      'Amount': '$ 564,000,000',
      'Year': '',
      'Investor': 'State Street',
      'Order': 31
    },
    {
      'Logo': cashedgenew,
      'Name': 'CashEdge',
      'Description': 'Saas Payments and Risk Management Platform',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 32,000,000',
      'Year': '',
      'Investor': 'Susquehanna Growth Equity and RBC',
      'Order': 32
    },
    {
      'Logo': velocitynew,
      'Name': 'Velocity Express',
      'Description': 'Time-Critical Logistics Company',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 40,000,000',
      'Year': '',
      'Investor': 'Context Capital',
      'Order': 33
    },
    {
      'Logo': CheckSmart300w,
      'Name': 'Check Smart',
      'Description': 'Check Casher and Short-Term Lender',
      'MM': 'PRIOR',
      'Type': 'Acquisition',
      'Amount': '$ 180,000,000',
      'Year': '',
      'Investor': 'Diamond Castle',
      'Order': 34
    },
    {
      'Logo': newnew,
      'Name': 'NEW Company',
      'Description': 'Outsourced Insurance Services Company',
      'MM': 'PRIOR',
      'Type': 'Debt Raise',
      'Amount': '$ 380,000,000',
      'Year': '',
      'Investor': 'CIBC',
      'Order': 35
    },
    {
      'Logo': newnew,
      'Name': 'NEW Company',
      'Description': 'Outsourced Insurance Services Company',
      'MM': 'PRIOR',
      'Type': 'Acquisition',
      'Amount': '$ 271,000,000',
      'Year': '',
      'Investor': 'Th Lee Putnam Ventures',
      'Order': 36
    },
    {
      'Logo': resmaenew,
      'Name': 'ResMAE',
      'Description': 'Non-Prime Mortgage Lender',
      'MM': 'PRIOR',
      'Type': 'Equity Raise',
      'Amount': '$ 25,000,000',
      'Year': '',
      'Investor': 'Th Lee Putnam Ventures',
      'Order': 37
    },
  ]



export { transactions };